import 'selectric';

const handleSelect = () => {
	$('.js-simple-select').selectric({
	    disableOnMobile: false,
	    nativeOnMobile: false
	});
};

handleSelect();
